import { useCallback } from "react";
import { FaCheck } from "react-icons/fa6";

import { Switch, Text } from "../../../elements";
import { useCookieConsent } from "../hooks";
import { StringFormat } from "../../../support";
import { cookieControlModalData } from "./cookie-control-modal.data";

import type { CookieConsents } from "../cookie-consent.types";

import styles from "./cookie-control-modal-items.module.css";

export function CookieControlModalItems() {
  const { cookieConfig, setCookieConfig, pageInteraction } = useCookieConsent();
  const handleChange = useCallback(
    (name: keyof CookieConsents, title: string) => {
      if (!cookieConfig) return;
      return (e: React.ChangeEvent<HTMLInputElement>) => {
        const updatedConsent = {
          ...cookieConfig,
          cookies: {
            ...cookieConfig.cookies,
            [name]: e.target.checked,
          },
        };
        setCookieConfig(updatedConsent);
        pageInteraction?.(`${e.target.checked ? "check" : "uncheck"}: ${StringFormat.formatSlug(title)}`);
      };
    },
    [cookieConfig, setCookieConfig]
  );

  return (
    <div className={styles.Container}>
      <div className={styles.Item}>
        <FaCheck size={40} />
        <div className={styles.TextWrapper}>
          <Text as="h4" variant="web-title-medium">
            Essenciais
          </Text>
          <Text>
            São cookies indispensáveis pra você acelerar por aqui e manter suas
            preferências de navegação. Sem eles, nada de Webmotors. Triste, né?
          </Text>
        </div>
      </div>

      {cookieControlModalData.map(({ title, name, text }) => (
        <div key={name} className={styles.Item}>
          <Switch
            name={name}
            checked={cookieConfig?.cookies?.[name as keyof CookieConsents]}
            onChange={handleChange(name as keyof CookieConsents, title)}
            variant="complementary"
            dataQA={`cookie-control-switch-${name}`}
          />
          <div className={styles.TextWrapper}>
            <Text as="h4" variant="web-title-medium">
              {title}
            </Text>
            <Text>{text}</Text>
          </div>
        </div>
      ))}
    </div>
  );
}
